import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";

import {
  Area,
  AreaChart,
  CartesianGrid,
  Line,
  LineChart,
  Rectangle,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const data = [
  {
    year: "01",
    value: 7660800000,
  },
  {
    year: "02",
    value: 35020800000,
  },
  {
    year: "03",
    value: 57127680000,
  },
  {
    year: "04",
    value: 63037440000,
  },
  {
    year: "05",
    value: 68728320000,
  },
];

const RevenueGrowthChart = () => {
  return (
    <>
      <article className="wallet-chart">
        <div className="section-chart py-5">
          <ResponsiveContainer width="100%" height={400}>
            <LineChart data={data}>
              <Line
                dataKey="value"
                stroke="#e11f1c"
                strokeWidth={2}
                fill="url(#colorUv)"
              />
              <XAxis
                dataKey="year"
                axisLine={false}
                tickLine={false}
                tickCount={12}
                type="category"
                tick={false}
              />
              <YAxis
                dataKey="value"
                axisLine={false}
                tickLine={false}
                tickCount={9}
                width={120}
                tickFormatter={(number) => `$${number}`}
                tick={{
                  fill: "#404040",
                  fontWeight: "500",
                  fontSize: "0.8rem",
                }}
              />

              <Tooltip
                content={<CustomTooltip />}
                cursor={{
                  stroke: "#e11f1c",
                  strokeWidth: 1,
                  strokeDasharray: 5,
                }}
              />
              <CartesianGrid opacity={0.5} vertical={false} />
            </LineChart>
          </ResponsiveContainer>
          <div className="chart-stats pt-3">
            {/* <Row className="justify-content-between">
              {data.map((item) => {
                return (
                  <>
                    <Col xs={2}>
                      <p className="legend-cell primary">{item["year"]}</p>
                    </Col>
                  </>
                );
              })}
            </Row> */}
            <Row className="padding-from-left-for-chart">
            <Col className="text-center col col-md-2">
              <p className="legend-cell_1">Year</p>
            </Col>
            {data.map((item) => {
              return (
                <>
                  <Col className="col col-md-2">
                    <p className="legend-cell_1">{item["year"]}</p>
                  </Col>
                </>
              );
            })}
          </Row>
            <Row className="align-items-center pt-3 justify-content-between hide-on-responsive">
              {data.map((item) => {
                return (
                  <>
                    <Col xs={2}>
                      <p className="legend-cell">
                        $ {item["value"].toLocaleString()}
                      </p>
                    </Col>
                  </>
                );
              })}
            </Row>
          </div>
        </div>
      </article>
    </>
  );

  function CustomTooltip({ active, payload, label }) {
    if (active) {
      return <div></div>;
    }
    return null;
  }
};

export default RevenueGrowthChart;
